var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"obi-content"},[_c('div',{staticClass:"obi-content--sidebar"},[_vm._t("sidebar")],2),_c('div',{staticClass:"obi-content--content",style:(_vm.isAdmin ? 'margin-top:0px' : 'margin-top:-82px;')},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }